import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Disclaimer from "./Disclaimer";
import { stateLogos } from "./stateLogos";

const HeroKycIntro = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const navigate = useNavigate();

  const state = localStorage.getItem("kyc_state");
  const logo = stateLogos[state];

  const handleLogout = () => {
    localStorage.clear();
    try {
      sessionStorage.removeItem("isAuthenticated");
    } catch {}
    navigate("/video-login", { replace: true });
  };

  return (
    <>
      {/* ✅ Logout bar — sits OUTSIDE the hero section, no overlap */}
      <div
        style={{
          background: "rgba(7, 21, 32, 0.95)",
          borderBottom: "1px solid rgba(64,190,180,0.1)",
          display: "flex",
          justifyContent: "flex-end",
          padding: "10px 20px",
        }}
      >
        <button
          onClick={handleLogout}
          style={{
            padding: "8px 20px",
            borderRadius: "8px",
            background: "rgba(255,255,255,0.05)",
            border: "1px solid rgba(255,255,255,0.2)",
            color: "#fff",
            cursor: "pointer",
            fontSize: "14px",
          }}
        >
          Logout
        </button>
      </div>

      <section
        className="relative flex items-center justify-center px-4"
        style={{
          background:
            "linear-gradient(160deg, #071520 0%, #0a1e2e 35%, #071018 100%)",
          overflow: "hidden",
          minHeight: "calc(100vh - 120px)", // accounts for banner + logout bar
          paddingTop: "40px",
          paddingBottom: "48px",
        }}
      >
        {/* GRID */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `
              linear-gradient(rgba(64,190,180,0.03) 1px, transparent 1px),
              linear-gradient(90deg, rgba(64,190,180,0.03) 1px, transparent 1px)
            `,
            backgroundSize: "48px 48px",
            pointerEvents: "none",
          }}
        />

        {/* Card */}
        <div
          className="max-w-3xl w-full text-center rounded-3xl text-white relative"
          style={{
            background: "rgba(10, 25, 40, 0.92)",
            backdropFilter: "blur(12px)",
            border: "1px solid rgba(64,190,180,0.2)",
            boxShadow: `
              0 0 0 1px rgba(255,255,255,0.03) inset,
              0 24px 64px rgba(0,0,0,0.6),
              0 0 48px rgba(64,190,180,0.07)
            `,
            padding: "40px 24px 40px", // reduced side padding for mobile
            zIndex: 10,
          }}
        >
          {/* STATE LOGO */}
          {logo && (
            <div
              style={{
                width: "160px",
                height: "160px",
                borderRadius: "50%",
                margin: "0 auto 20px",
                background: "#ffffff",
                border: "3px solid rgba(64,190,180,0.5)",
                boxShadow:
                  "0 0 0 4px rgba(64,190,180,0.15), 0 8px 24px rgba(0,0,0,0.3)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                padding: "14px",
              }}
            >
              <img
                src={logo}
                alt="state logo"
                style={{ width: "100%", height: "100%", objectFit: "contain", background: "#ffffff",mixBlendMode: "multiply", }}
              />
            </div>
          )}

          {state && (
            <p style={{ color: "#40BEB4", marginBottom: "10px" }}>
              {state} Forest Department
            </p>
          )}

          <h2
            className="text-4xl font-bold mb-4"
            style={{ color: "#40BEB4" }}
          >
            Welcome to Video KYC
          </h2>

          <p
            style={{
              color: "rgba(255,255,255,0.7)",
              marginBottom: "8px",
              fontSize: "14px",
            }}
          >
            Aadhaar-based identity verification using DigiLocker for KYC
            purposes.
          </p>

          <p
            style={{
              color: "rgba(255,255,255,0.55)",
              marginBottom: "28px",
              fontSize: "15px",
            }}
          >
            Complete your KYC process quickly, securely, and conveniently.
          </p>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              marginBottom: "28px",
            }}
          >
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
              className="scale-125"
              style={{ accentColor: "#40BEB4" }}
            />
            <span
              style={{ fontSize: "14px", color: "rgba(255,255,255,0.8)" }}
            >
              I confirm that the details provided will be valid.
            </span>
          </div>

          <button
            disabled={!isChecked}
            onClick={() => setShowDisclaimer(true)}
            style={{
              padding: "14px 40px",
              borderRadius: "10px",
              background: isChecked
                ? "linear-gradient(135deg, #1a8a82, #40BEB4)"
                : "rgba(64,190,180,0.15)",
              color: isChecked ? "#071520" : "rgba(255,255,255,0.3)",
              fontWeight: "700",
              letterSpacing: "1px",
              fontSize: "14px",
              border: isChecked ? "none" : "1px solid rgba(64,190,180,0.2)",
              cursor: isChecked ? "pointer" : "not-allowed",
              transition: "all 0.2s",
              boxShadow: isChecked
                ? "0 4px 20px rgba(64,190,180,0.3)"
                : "none",
            }}
          >
            Start Video KYC Application
          </button>
        </div>
      </section>

      {showDisclaimer && (
        <Disclaimer
          onReject={() => setShowDisclaimer(false)}
          onAccept={() => navigate("/kyc-form")}
        />
      )}
    </>
  );
};

export default HeroKycIntro;